import { styled } from 'styled-components';
import { Utils, Grid2 } from 'team-hero-ui';

const { pxToRem } = Utils;

export const ItemWrapper = styled(Grid2)`
  min-height: ${pxToRem(90)};
`;
